export default __webpack_public_path__ + "static/media/arrow-right-black.ad62ca9e.svg";